import React, { forwardRef, lazy, Suspense, useLayoutEffect, useRef, useState } from "react";
const iconSizes = {
    "sm": "16px",
    "md": "20px",
    "lg": "24px",
    "xl": "40px",
    "2xl": "48px",
};
export const createLazyIconComponent = (importer) => {
    const iconCache = {};
    const Icon = ({ style = "outlined", size = "lg", ...svgProps }, ref) => {
        const [computedSize, setComputedSize] = useState(size);
        const svgRef = useRef(null);
        useLayoutEffect(() => {
            const element = ref && "current" in ref ? ref.current : svgRef.current;
            if (element) {
                const computedStyle = getComputedStyle(element);
                const cssSize = computedStyle.getPropertyValue("--atlas-icon-size");
                if (cssSize && cssSize in iconSizes) {
                    setComputedSize(cssSize);
                }
            }
        }, [ref, svgRef.current]);
        const cacheKey = `${style}-${computedSize}`;
        if (!iconCache[cacheKey]) {
            iconCache[cacheKey] = lazy(() => importer(style, computedSize));
        }
        const IconComponent = iconCache[cacheKey];
        const iconSize = iconSizes[computedSize] || "24px";
        const iconSizeNum = parseInt(iconSize, 10);
        return (React.createElement("svg", { ref: ref || svgRef, width: iconSize, height: iconSize, viewBox: `0 0 ${iconSizeNum} ${iconSizeNum}`, ...svgProps },
            React.createElement(Suspense, { fallback: null },
                React.createElement(IconComponent, null))));
    };
    return forwardRef(Icon);
};
//# sourceMappingURL=create-lazy-icon-component.js.map